import Field from 'bz-core-controls/controls/form/field/field';
import FieldSelect from 'bz-core-controls/controls/form/field/field-select';

import Button from 'bz-core-controls/controls/general/button';
import type { ChangeEvent } from 'react';
import React, { useCallback, useMemo } from 'react';

export interface IProps {
  selectValues?: boolean;
  valuesToAdd?: any[];
  maxLength?: number;
  onAdd: (item: string) => void;
}

const ListAdd: React.FC<IProps> = React.memo(({ selectValues, valuesToAdd, maxLength, onAdd }) => {
  const [item, setItem] = React.useState('');

  const hasItem = useMemo(() => {
    return !!item.trim();
  }, [item]);

  const doAdding = useCallback(() => {
    onAdd(item);
    setItem('');
  }, [item]);

  let field;
  if (selectValues) {
    field = (
      <FieldSelect
        includeNone={false}
        label="Please select a value to add"
        lookup={true}
        lookupItems={valuesToAdd}
        liveOnChange={true}
        value={item}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setItem(e.target.value)}
        onEnterKeyDown={doAdding}
      />
    );
  } else {
    field = (
      <Field
        className=""
        label="Type new list value"
        liveOnChange={true}
        maxLength={maxLength}
        value={item}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setItem(e.target.value)}
        onEnterKeyDown={doAdding}
      />
    );
  }

  return (
    <div className="flex gap-2">
      <div className="grow">{field}</div>
      <div className="grow-0 self-center align-middle pt-4">
        <Button label="Add to List" disabled={!hasItem} onClick={doAdding} />
      </div>
    </div>
  );
});

ListAdd.displayName = 'ListAdd';

export default ListAdd;
